import { render, staticRenderFns } from "./ShippingConfig.vue?vue&type=template&id=3afe3dfa&scoped=true"
import script from "./ShippingConfig.vue?vue&type=script&lang=js"
export * from "./ShippingConfig.vue?vue&type=script&lang=js"
import style0 from "./ShippingConfig.vue?vue&type=style&index=0&id=3afe3dfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afe3dfa",
  null
  
)

export default component.exports